/* eslint-disable max-len */
import { MasterQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import * as questionIds from "./questionIds";

export const masterConfig: MasterQuestionConfig[] = [
    {
        id: questionIds.IaptCarryOutPhq9Assessment,
        questionText: "Do you want to carry out a PHQ9?",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptCarryOutGad7Assessment,
        questionText: "Do you want to carry out a GAD7?",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptCarryOutWsasAssessment,
        questionText: "Do you want to carry out a WSAS?",
        canBeDisabled: false
    }
];
/* eslint-enable max-len */
